// Augments admin-authored HTML (news/pages/press/service bodies, KVKK text,
// training detail) so every <img> that the rich-text editor inserted is
// loaded lazily and decoded off the main thread. Safe to call on sanitized
// HTML; it leaves tags that already declare a `loading` attribute alone.
export const lazyImgs = (html) =>
  typeof html === "string"
    ? html.replace(
        /<img\b(?![^>]*\bloading=)([^>]*?)>/gi,
        '<img loading="lazy" decoding="async"$1>',
      )
    : html;
